import React, { Component } from 'react';
import ReactCompareImage from "react-compare-image";
import SimpleImageSlider from "react-simple-image-slider";

class Demo extends Component {
  render() {

    if(this.props.data){
      var projects_matting = this.props.data.projects.map(function(projects){
        if(projects.cateogry=='matting'){
          var display=<ReactCompareImage handleSize={50} leftImage={projects.before} rightImage={projects.after} />
          return <div key={projects.title} className="columns demo-item">
        <div className="item-wrap">
        <h2><a href={projects.project_url}>{projects.title}</a></h2>
        <h3>{projects.description}</h3>
        {display}
        </div>
      </div>
        }})

      var projects_comp = this.props.data.projects.map(function(projects){
        if(projects.cateogry=='comp'){
          var display=<video width="500" height="300" controls autoPlay loop><source src={projects.url} type="video/mp4"/></video>
          return <div key={projects.title} className="columns demo-item">
        <div className="item-wrap">
        <h2><a href={projects.project_url}>{projects.title}</a></h2>
        <h3>{projects.description}</h3>
        {display}
        </div>
      </div>
        }})

      var projects_mobile = this.props.data.projects.map(function(projects){
        if(projects.cateogry=='mobile'){
            const images = [
            { url: projects.images[0]},
            { url: projects.images[1]},
            { url: projects.images[2]},
            { url: projects.images[3]},
            { url: projects.images[4]},
            { url: projects.images[5]}];
            var display=
        <SimpleImageSlider
        width={307}
        height={600}
        images={images}
        showBullets={true}
        showNavs={true}
        autoPlay={true}
        navMargin={10}
        navSize={50}
        bgColor={"#505050"}
        navStyle={1}
      />
        return <div key={projects.title} className="columns demo-item">
        <div className="item-wrap">
        <h2><a href={projects.project_url}>{projects.title}</a></h2>
        <h3>{projects.description}</h3>
        {display}
        </div>
      </div>
      }})


    var projects_aigc = this.props.data.projects.map(function(projects){
        if(projects.cateogry=='aigc'){
          var display=<video width="1000" height="600" controls><source src={projects.url} type="video/mp4"/></video>
          return <div key={projects.title} className="columns demo-item">
        <div className="item-wrap">
        <h2><a href={projects.project_url}>{projects.title}</a></h2>
        <h3>{projects.description}</h3>
        {display}
        </div>
      </div>
        }})

    }


    return (
      <section id="demo">

      <div className="row">
         <div className="twelve columns collapsed">
            <h1>Check out some of my works.</h1>
            <div id="demo-wrapper" className="bgrid-halves cf">
                {projects_matting}
            </div>
            <div id="demo-wrapper" className="bgrid-halves cf">
                {projects_comp}
            </div>
            <div id="demo-wrapper" className="bgrid-whole cf">
                {projects_aigc}
            </div>
            <div id="demo-wrapper" className="bgrid-thirds cf">
                {projects_mobile}
            </div>
            
            
          </div>
      </div>
   </section>
    );
  }
}

export default Demo;